import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {formatDateString} from "../../../utils/daysOptions";
import {TodayTwoTone, HomeRepairServiceTwoTone, MapsHomeWorkTwoTone} from "@mui/icons-material";
import {CreditInterface} from "../../../services/interface/query/credit-interface";
import {ItemInfo, ItemNumber, Qualification} from "../../components/ViewData";
import {Person} from "../../../services/interface/query/person";
import {Skeleton} from "../../../components/general/Skeleton";
import * as IconReactFa from "react-icons/fa6";
import {Tooltip} from "@material-tailwind/react";
import CustomTable from "../../../components/general/CustomTable";
import {useFindCredit} from "../../../services/apis/apiCredit";
import NotPermissionComponent from "../NotPermissionComponent";
import NoRecords from "../../components/NoRecords";
interface Props {
    person?: Person;
}
export default function Credits({person}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const [list, setList] = React.useState<CreditInterface[] | undefined>()
    const styleIcon = 'min-w-[20px] min-h-[20px]'

    const {
        mutate: getBankCreditInformation,
        data: successBankCredit,
        error: errorBankCredit,
        isPending: loadingBankCredit,
    } = useFindCredit()

    useEffect(() => {
        if (person?.identification) {
            getBankCreditInformation({identifier: person?.identification, msj: t('credits')})
        }
    }, []);

    useEffect(() => {
        if (successBankCredit) {
            setList(successBankCredit)

        }
    }, [successBankCredit]);

    function getValue(value: number | undefined) {
        if (value || value === 0) {
            return value
        }
        return '-'
    }

    const styleQualification = 'flex justify-center';
    const styleInfo = 'text-[13px]';
    const styleCredit = 'px-1 py-4 text-[15px] font-light';

    function RenderCredits() {
        if (list && list.length > 0) {
            return (
                <>
                    {
                        list.map((item, index) => (
                            <div key={index}>
                                <h5>{`${t('register')} #${index + 1}`}</h5>
                                <div className={'mt-1 flex flex-col sm:flex-row gap-9 sm:gap-3 p-0'}>
                                    <div className={`w-full sm:w-[12%] md:w-[8%] xl:w-[6%] flex flex-row sm:flex-col gap-3 
                                items-center justify-center custom-card py-3 h-auto`}>
                                        <Tooltip className={"bg-header"} content={
                                            <ItemInfo label={t('owner-type-code')}
                                                      text={item.ownerIdTypeCode && item.ownerIdTypeCode.length > 3 ? item.ownerIdTypeCode : item.ownerIdType}
                                                      icon={<IconReactFa.FaCreditCard className={styleIcon}/>}/>
                                        }>
                                            <div className={styleQualification}>
                                                <Qualification
                                                    label={t('owner-type')}
                                                    value={item.ownerIdType && item.ownerIdType.length > 3 ? item.ownerIdTypeCode : item.ownerIdType}
                                                />
                                            </div>
                                        </Tooltip>
                                        <Tooltip className={"bg-header"} content={
                                            <ItemInfo label={t('product-type')} text={item?.productDescription}
                                                      icon={<IconReactFa.FaCreditCard className={styleIcon}/>}/>
                                        }>
                                            <div className={styleQualification}>
                                                <Qualification label={t('product-type')} value={item.productCode}/>
                                            </div>
                                        </Tooltip>
                                        <Tooltip className={"bg-header"} content={
                                            <ItemInfo label={t('qualification')} text={item?.qualificationCodeDescription}
                                                      icon={<IconReactFa.FaStarHalfStroke className={styleIcon}/>}/>
                                        }>
                                            <div className={styleQualification}>
                                                <Qualification label={t('qualification')} value={item.qualificationCode}/>
                                            </div>
                                        </Tooltip>
                                        <Tooltip className={"bg-header"} content={
                                            <ItemInfo label={t('type')} text={item?.creditTypeDescription}
                                                      icon={<IconReactFa.FaCommentsDollar className={styleIcon}/>}/>
                                        }>
                                            <div className={styleQualification}>
                                                <Qualification label={t('risk')} value={item.creditTypeCode}/>
                                            </div>
                                        </Tooltip>
                                    </div>
                                    <div className={'flex flex-col w-full sm:w-[87%] md:w-[92%] xl:w-[93%] custom-card p-3 gap-2 justify-center'}>
                                        <div className={'w-full flex flex-col gap-3'}>
                                            <div className={'grid grid-cols-1 md:grid-cols-3 gap-2'}>
                                                <ItemInfo
                                                    classNameValue={styleInfo}
                                                    label={t('ent-name')}
                                                    text={item.financialInstName}
                                                    icon={<HomeRepairServiceTwoTone className={styleIcon}/>}/>
                                                <ItemInfo
                                                    classNameValue={styleInfo}
                                                    label={t('ent-type')}
                                                    text={item.financialInstType}
                                                    icon={<MapsHomeWorkTwoTone className={styleIcon}/>}/>
                                                <ItemInfo
                                                    className={'md:ml-auto min-w-[150px]'}
                                                    classNameValue={styleInfo}
                                                    label={t('date')}
                                                    text={formatDateString(item.dateReport)}
                                                    icon={<TodayTwoTone className={styleIcon}/>}/>
                                            </div>
                                        </div>
                                        <div className={'flex flex-col lg:flex-row gap-4 my-1 w-full'}>
                                            <div className={'flex flex-col gap-2 w-full lg:w-[35%]'}>
                                                <ItemNumber
                                                    label={t('current-balance')}
                                                    value={`$${getValue(item.valTotalCreditOutstanding)}`}/>
                                                <ItemNumber
                                                    label={t('punishment')}
                                                    value={`$${getValue(item.valOverduePortfolio)}`}/>
                                                <ItemNumber
                                                    label={t('mora')}
                                                    value={`$${getValue(item.valMora)}`}/>
                                                <ItemNumber
                                                    label={t('val-demand-judicial')}
                                                    value={`$${getValue(item.valDemandJudicial)}`}/>
                                            </div>
                                            <CustomTable
                                                classNameTable={'w-full lg:w-[65%]'}
                                                classNameItemHeader={'py-6'}
                                                classNameBody={'!border border-transparent text-end'}
                                                header={[
                                                    t('val-interest-not-accrued'),
                                                    `1 - 30`,
                                                    `31 - 90`,
                                                    `91 - 180`,
                                                    `181 - 360`,
                                                    `${t('val-fee-due-greater')} 360`
                                                ]}
                                                listElement={[
                                                    {row: [
                                                            <div className={styleCredit}>{`$${getValue(item.valInterestNotAccrued)}`}</div>,
                                                            <Tooltip className={"bg-header"} content={`${t('val-fee-due')} 1 - 30`}>
                                                                <div className={styleCredit}>{`$${getValue(item.valFeeDue01To30)}`}</div>
                                                            </Tooltip>,
                                                            <Tooltip className={"bg-header"} content={`${t('val-fee-due')} 31 - 90`}>
                                                                <div className={styleCredit}>{`$${getValue(item.valFeeDue31To90)}`}</div>
                                                            </Tooltip>,
                                                            <Tooltip className={"bg-header"} content={`${t('val-fee-due')} 91 - 180`}>
                                                                <div className={styleCredit}>{`$${getValue(item.valFeeDue91To180)}`}</div>
                                                            </Tooltip>,
                                                            <Tooltip className={"bg-header"} content={`${t('val-fee-due')} 181 - 360`}>
                                                                <div className={styleCredit}>{`$${getValue(item.valFeeDue181To360)}`}</div>
                                                            </Tooltip>,<Tooltip className={"bg-header"} content={`${t('val-fee-due')} ${t('val-fee-due-greater')} 360`}>
                                                                <div className={styleCredit}>{`$${getValue(item.valFeeDueGreaterThan360)}`}</div>
                                                            </Tooltip>,
                                                        ]}
                                                ]}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </>
            )
        } else {
            return <NoRecords/>
        }
    }

    return (
        <div className={'flex flex-col gap-3'}>
            <h3>{t('credits')}</h3>
            <NotPermissionComponent
                title={'/income/current'}
                loading={loadingBankCredit}
                error={errorBankCredit}
                component={<RenderCredits/>}
            />
        </div>
    )
}

interface ItemCreditProps {
    label: string;
    value?: string | number;
    className?: string;
    loading?: boolean;
}
export function ItemCredit({label, value, className, loading}: ItemCreditProps) {
    return(
        <div className={`${className} flex flex-col`}>
            <div className={'text-[13px] bg-gray-200 h-full flex items-center font-bold text-header'}>{`${label}:`}</div>
            {
                loading ? <Skeleton/> :
                    <div className={`font-sans px-2 py-3 text-end`}>{value}</div>
            }
        </div>
    )
}
